import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TokenStorageService } from 'src/app/shared/service/token-storage.service';
import { UserStatus } from '../enum/user-status';

@Injectable({ providedIn: 'root' })
export class AuthUserGuard implements CanActivate {
  constructor(private session: TokenStorageService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const auth = this.session.getAuth();

    if (!auth?.token) {
      this.router.navigate(['/login']);
      return false;
    }

    if (auth.status !== UserStatus.AUTHENTICATED) {
      switch (auth.status) {
        case UserStatus.NOTVERIFIED:
          this.router.navigate(['/confirmation']);
          break;

        case UserStatus.INCOMPLETE:
          if (state.url !== '/login-c') {
            this.router.navigate(['/login-c']);
            return false;
          }
          return true;

        default:
          this.router.navigate(['/login']);
      }
      return false;
    }
    return true;
  }
}
